import { Spinner } from '@talentmesh/ui/components/spinner';
import { TypographyMuted } from '@talentmesh/ui/components/typography';
import { ReactNode } from 'react';
import UIStrings from '@/Utils/UIStrings';

interface SectionLoadingStateProps {
    isLoading: boolean;
    loadingFailed: boolean;
    children: ReactNode;
}

/**
 * Inline loading/error wrapper scoped to a single settings section.
 *
 * Unlike LoadingTab (which fills an entire tab with a fixed-height spinner),
 * this keeps its footprint compact so multiple sections can resolve their
 * loading states independently within the same tab.
 */
const SectionLoadingState = ({ isLoading, loadingFailed, children }: SectionLoadingStateProps) => {
    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-8">
                <Spinner className="text-primary size-6" />
            </div>
        );
    }

    if (loadingFailed) {
        return <TypographyMuted>{UIStrings.PleaseRefresh}</TypographyMuted>;
    }

    return children;
};

export default SectionLoadingState;
